export enum ConnectedAccountActivityStatus {
    Pending = 'pending',
    Settled = 'settled',
    Cancelled = 'cancelled',
}
